import { render, staticRenderFns } from "./10.vue?vue&type=template&id=173a8526&scoped=true&"
import script from "./10.vue?vue&type=script&lang=js&"
export * from "./10.vue?vue&type=script&lang=js&"
import style0 from "./10.vue?vue&type=style&index=0&id=173a8526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a8526",
  null
  
)

export default component.exports